import { render, staticRenderFns } from "./UserHeader.vue?vue&type=template&id=5802b468&scoped=true&"
import script from "./UserHeader.vue?vue&type=script&lang=js&"
export * from "./UserHeader.vue?vue&type=script&lang=js&"
import style0 from "./UserHeader.vue?vue&type=style&index=0&id=5802b468&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5802b468",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/dostartu.pl/app.startzone.online/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5802b468')) {
      api.createRecord('5802b468', component.options)
    } else {
      api.reload('5802b468', component.options)
    }
    module.hot.accept("./UserHeader.vue?vue&type=template&id=5802b468&scoped=true&", function () {
      api.rerender('5802b468', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/UserHeader.vue"
export default component.exports